import React from 'react';
import { readableTemplateLabel } from './templateKeyPresentation';

const STATUS_LABELS = {
  draft: 'Taslak',
  in_review: 'İncelemede',
  approved: 'Onaylandı',
  active: 'Yayında',
  rejected: 'Reddedildi',
  archived: 'Arşivde'
};

const SEGMENT_LABELS = {
  RESET: 'Sıfırlama',
  FRICTION: 'Sürtünme',
  STABLE: 'Dengeli',
  STRONG: 'Güçlü'
};

const VARIANT_LABELS = {
  primary: 'Birincil',
  secondary: 'İkincil',
  reassurance: 'Destekleyici'
};

function statusLabel(status) {
  return STATUS_LABELS[String(status || '').toLowerCase()] || String(status || '-');
}

function segmentLabel(segment) {
  return SEGMENT_LABELS[String(segment || '').toUpperCase()] || String(segment || '-');
}

function variantLabel(variant) {
  return VARIANT_LABELS[String(variant || '').toLowerCase()] || String(variant || '-');
}

export default function ApprovalQueueTable({ rows = [], onApprove, onReject, onActivate, onArchive }) {
  if (!rows.length) {
    return <p className="text-sm text-slate-500">İnceleme sırasında bekleyen şablon bulunmuyor.</p>;
  }

  return (
    <div className="space-y-2">
      {rows.map((row) => (
        <div key={row.id} className="flex flex-wrap items-center justify-between rounded-xl border border-slate-200 dark:border-slate-800 p-3">
          <div>
            <p className="font-bold text-slate-800 dark:text-white">{readableTemplateLabel(row.template_key, row.version).title}</p>
            <p className="text-[11px] text-slate-500">{readableTemplateLabel(row.template_key, row.version).technicalKey}</p>
            <p className="text-xs text-slate-500">{segmentLabel(row.segment)} / {variantLabel(row.variant)} / {statusLabel(row.status)}</p>
          </div>
          <div className="flex gap-2">
            <button className="rounded-lg bg-emerald-600 text-white px-3 py-1 text-xs font-bold" onClick={() => onApprove?.(row.id)}>Onayla</button>
            <button className="rounded-lg bg-rose-600 text-white px-3 py-1 text-xs font-bold" onClick={() => onReject?.(row.id)}>Reddet</button>
            <button className="rounded-lg bg-indigo-600 text-white px-3 py-1 text-xs font-bold" onClick={() => onActivate?.(row.id)}>Yayına Al</button>
            <button className="rounded-lg bg-slate-700 text-white px-3 py-1 text-xs font-bold" onClick={() => onArchive?.(row.id)}>Arşivle</button>
          </div>
        </div>
      ))}
    </div>
  );
}
